const togglers = {
  gasAhead: 'Gas Day-Ahead',
  gasM: 'Gas M+1',
  therm: 'p/therm',
  mwh: '€/MWh',
};

export default togglers;
